import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { InputNumber } from 'ui/styled';
var ConfidenceInput = function (_a) {
    var _b = _a.value, value = _b === void 0 ? 5 : _b, onChange = _a.onChange;
    return (_jsx(InputNumber, { "data-test": "addOfficeConfidenceString", value: value, onChange: onChange, min: 1, max: 5, step: 1, maxLength: 1, parser: function (str) { return parseInt(str, 10); } }));
};
export default ConfidenceInput;
